import { env } from 'common/config/env'

import { MetabaseDashboard } from './MetabaseDashboard'

export const MetabaseAccountOverview = () => {
  const dashboardId = env.metabaseAccountDashboardId

  if (!dashboardId) {
    // eslint-disable-next-line no-console
    console.error('Dashboard ID is not defined')
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="rounded bg-coolGray-100 px-6 py-4 text-base-700">
          Unable to load the account overview dashboard. The dashboard
          configuration is missing.
        </div>
      </div>
    )
  }

  return <MetabaseDashboard dashboardId={dashboardId} />
}
